/* eslint-disable */
import { REHYDRATE } from 'redux-persist';
import { I18N_LANG, I18N_PERSIST_KEY } from '../../../Constants/I18n/I18n.constants';
import { I18N_CHANGE_LOCALE } from './I18n.types';

/** @typedef {{ direction: I18nEntityDirections, lang: I18nEntityLangs }} State */
/** @typedef {ActionAny} I18nActions */

/**
 * Create the state for the `i18nReducer` before `redux-persist` kicks in
 * @param {I18nService} i18nService The `I18nService`
 * @returns {State} The initial state before `redux-persist` kicks in
 */
const createPrePersistI18nState = (i18nService) => {
  i18nService.setLocale({ lang: I18N_LANG });
  const locale = i18nService.getLocale();
  const locales = i18nService.getLocales();
  return {
    locale,
    locales,
  };
};

/**
 * Create the `i18nReducer`
 * @param {InjectablesForReducer} injectables The _injectable_'s required by this reducer
 * @returns {Reducer<State, I18nActions>} The `i18nReducer`
 */
const i18nReducer = ({ i18nService }) => (state = createPrePersistI18nState(i18nService), action) => {
  switch (action.type) {
    case REHYDRATE: {
      if (action.key !== I18N_PERSIST_KEY || action.payload == null) {
        return state;
      }
      const { _persist, ...newState } = action.payload;
      return newState;
    }
    case I18N_CHANGE_LOCALE: {
      i18nService.setLocale({ lang: action.payload });
      const locale = i18nService.getLocale();
      return {
        ...state,
        locale,
      };
    }
    default: {
      return state;
    }
  }
};

export default i18nReducer;
